import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const prospectRoutes = {
  path: '/client',
  name: 'client',
  component: Layout,
  redirect: '/accounts',
  alwaysShow: true,
  meta: {
    title: 'Comptes',
    icon: 'mdi:account-outline',
    permissions: [P.COMPTES.BROWSE],
  },
  children: [
    // Voir la listes des clients
    {
      path: '/accounts',
      name: 'comptes',
      meta: { title: 'Liste des comptes', icon: 'mdi:list-box-outline', noCache: true, permissions: [P.COMPTES.BROWSE] },
      component: () => import('@/views/accounts/Accounts.vue'),
    },

    // voir/éditer 1 compte en fonction d'un id
    {
      path: '/account/show/:id(\\d+)',
      component: () => import('@/views/accounts/showAccount.vue'),
      name: 'showAccount',
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: { title: 'Vue d\'un compte', permissions: [P.COMPTES.BROWSE] },
      hidden: true,
    },

    // Listes clients avec filtres avancés
    {
      path: '/comptes/listes',
      name: 'listesComptes',
      component: () => import('@/views/clients/ListesClients.vue'),
      meta: { title: 'Filtrage avancé', icon: 'mdi:filter-variant', noCache: true, permissions: [P.COMPTES.BROWSE] },
    },

    // Carte des comptes
    {
      path: '/comptes/carte',
      name: 'carteComptes',
      component: () => import('@/views/clients/CarteClients.vue'),
      meta: { title: 'Carte comptes', icon: 'mdi:map-marker-multiple', noCache: true, permissions: [P.COMPTES.BROWSE] },
    },
  ]
}

export default prospectRoutes
